export const pro_camera_inventories = {
  path: "pro-camera/inventories",
  savePath: "pro-camera/inventories",
  getFetchParams: (state) => ({
    status: state.proCameraFilters.status,
    sort_by: state.proCameraFilters.sortBy,
    sort_order: state.proCameraFilters.sortOrder,
  }),
  fields: {
    id: null,
    serial_number: "",
    camera_status: "pending",
    camera_id: null,
  },
  getFormData: (state) => ({
    id: state.selectedProCameraInventory.id,
    serial_number: state.selectedProCameraInventory.serial_number,
    status: state.selectedProCameraInventory.camera_status,
  }),
  saveCallBack: (_response, _state, dispatch) => {
    dispatch("fetchList");
  },
  validate: (state) => {
    return state.selectedProCameraInventory && state.selectedProCameraInventory.serial_number !== "";
  },
  reset: (commit) => {
    commit("SET_SELECTED_PRO_CAMERA_INVENTORY", {
      id: null,
      serial_number: "",
      camera_status: "pending",
      camera_id: null,
    });
  },
};
